// source: https://gist.github.com/yiwenl/8f2b735a2263bc93ee33
function saveFile(obj, options) {
  var type = options.type,
    fileName = options.fileName;
  // const str = JSON.stringify(obj);

  var blob = new Blob([obj], {
    type: type
  });
  var url = URL.createObjectURL(blob);
  var link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", fileName);
  link.click();
}
export default saveFile;